import { useContext } from "react";

import { storesContext } from "../index";

export default () => useContext(storesContext).backboneStore;
